import { isFulfilled, isPending, isRejected } from "../../utils/redux/action-utils.js";
import { onFulfilled, onPending, onRejected } from "../../utils/redux/state-utils.js";
//#region src/redux/build/extra-reducers.ts
var isActionFulfilled = (action) => isFulfilled(action, "build");
var isActionPending = (action) => isPending(action, "build");
var isActionRejected = (action) => isRejected(action, "build");
var extraReducers = (builder) => {
	builder.addMatcher(isActionFulfilled, onFulfilled).addMatcher(isActionPending, onPending).addMatcher(isActionRejected, onRejected);
};
//#endregion
export { extraReducers };

//# sourceMappingURL=extra-reducers.js.map